export default __webpack_public_path__ + "static/media/account-business.78316913.svg";